import { render } from "./AutomaticAccountingRecording.vue?vue&type=template&id=53e4b82d"
import script from "./AutomaticAccountingRecording.vue?vue&type=script&lang=js"
export * from "./AutomaticAccountingRecording.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__